const versionM = 'M51'
const versionA = 'A26'
export const version = '3.0.' + versionM + '.' + versionA
